// 「データを削除」の確認モーダルと実行（プライバシーポリシー 8. / GDPR 消去権の実装）。
//
// 削除は取り返しがつかないので、**何が消えるかを列挙してから**確認を取る。
// サーバー（D1）と端末（localStorage）の両方を消して初めて「削除した」と言える。
import { t } from '@/platform/i18n';
import { isRegistered, clearLocalPlayerData } from '@/platform/net/playerId';
import { deletePlayerRecord } from '@/platform/net/leaderboard';
import { el, openOverlay } from './modalChrome';

/**
 * 確認 → 削除まで面倒を見る。削除できたら true。
 * キャンセル、または削除に失敗して閉じた場合は false（呼び出し側は再描画しなくてよい）。
 */
export function confirmDeleteData(): Promise<boolean> {
  return new Promise((resolve) => {
    const registered = isRegistered();
    const { overlay, panel, close } = openOverlay();

    const title = el('div', 'hs-modal-title', t('portal.delete.title'));

    const body = el('div', 'hs-modal-body');
    const items = [t('portal.delete.item1'), t('portal.delete.item2'), t('portal.delete.item3')];
    const list = document.createElement('ul');
    for (const text of items) list.append(el('li', '', text));
    body.append(el('div', '', t('portal.delete.body')), list);
    // 未登録ならサーバーには何も無い。「ランキングから消えます」と言うと嘘になるので断る。
    if (!registered) body.append(el('div', 'hs-field-note', t('portal.delete.guestNote')));

    const warn = el('div', 'hs-modal-warn', t('portal.delete.warn'));
    const err = el('div', 'hs-modal-err', '');

    const row = el('div', 'hs-modal-row');
    const cancelBtn = el('button', 'hs-btn hs-btn-ghost', t('portal.delete.cancel'));
    const okBtn = el('button', 'hs-btn hs-btn-danger', t('portal.delete.submit'));
    row.append(cancelBtn, okBtn);

    panel.append(title, body, warn, err, row);

    const done = (v: boolean) => {
      close();
      resolve(v);
    };

    const run = async (): Promise<void> => {
      (okBtn as HTMLButtonElement).disabled = true;
      (cancelBtn as HTMLButtonElement).disabled = true;
      okBtn.textContent = t('portal.delete.working');
      err.textContent = '';
      const result = await deletePlayerRecord();
      // 登録済みならサーバーに実データがある＝消せていないので中断する。
      // 未登録ならサーバーには元から何も無いので、端末の掃除だけ進めてよい（オフラインでも消せる）。
      if (result !== 'ok' && registered) {
        // 🔴 401 は「時間をおけば直る」ものではない。**次にやることが違う**ので文言を分ける
        //    （パスキーを持っている人はセッションが要る＝実装順序(7)の所有者チェック）。
        err.textContent =
          result === 'unauthorized' ? t('portal.delete.needLogin') : t('portal.delete.error');
        okBtn.textContent = t('portal.delete.submit');
        (okBtn as HTMLButtonElement).disabled = false;
        (cancelBtn as HTMLButtonElement).disabled = false;
        return;
      }
      clearLocalPlayerData();
      done(true);
    };

    okBtn.addEventListener('click', () => void run());
    cancelBtn.addEventListener('click', () => done(false));
    overlay.addEventListener('mousedown', (e) => {
      if (e.target === overlay) done(false);
    });
  });
}
